import { Component, OnInit,AfterViewInit ,EventEmitter, ElementRef, Renderer2, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription, timer } from 'rxjs';
import { Location } from '@angular/common';

import { NotificationService } from './notification.service';
import { HelpService } from './help.service';
import { Dropdown } from '@eds/vanilla/dropdown/Dropdown';
import { Menu, Dialog } from '@eds/vanilla';
import { TranslateService } from '@ngx-translate/core';
import * as languageConfig from '../../assets/i18n/configuration/configuration.json';

declare var jQuery;

@Component({
  selector: 'app-head',
  templateUrl: './head.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./head.component.css'],
  providers: [NotificationService, HelpService]
})
export class HeadComponent {
  @ViewChild('timerDialog') timerDialog: ElementRef;
  @ViewChild('logoutDropdown') logoutDropdown: ElementRef;
  @ViewChild('menu') logoutMenu: ElementRef;

  timeoutDialog: Dialog;
  route: string;
  languageConfiguration: any;
  textDir:any;
  constructor(
    location: Location,
    public translate: TranslateService,
    private router: Router, private elementRef: ElementRef,
    private renderer: Renderer2,
    public http: HttpClient,
    private _notification: NotificationService,
    private helpService: HelpService
  ) {
      this.languageConfiguration = (languageConfig as any).default;
      translate.addLangs([this.languageConfiguration.languages]);
      translate.setDefaultLang(this.languageConfiguration.defaultLang);  
      let selectedLang = sessionStorage.getItem('selectedLang');
      this.textDir = sessionStorage.getItem('textDir');

      let langRegExp = new RegExp(this.languageConfiguration.languageRegexp);
      if(selectedLang){
        translate.use(selectedLang.match(langRegExp) ? selectedLang : this.languageConfiguration.defaultLang);  
      } else {
        const browserLang = translate.getBrowserLang();
        translate.use(browserLang.match(langRegExp) ? browserLang : this.languageConfiguration.defaultLang);  
      }    
      router.events.subscribe((val) => {
        const curUrl = location.path();
        const curUrlArr = curUrl.split('/');
        this.route = curUrlArr[1];
        if (val instanceof NavigationEnd){
          this.detectUrlChange = true;
        }else{
          this.detectUrlChange = false;
        }
        this.loginInfoObj = JSON.parse(this.returnLoginInfoObj());
        if (this.loginInfoObj !== null && this.detectUrlChange) {
        this.isLoggedin = this.loginInfoObj;
        this.stopTimer();
        this.startTimer();
      } else {
        this.isLoggedin = null;
      }
    });
    this.clickListener = renderer.listen(
    'document',
    'click',
    (event: MouseEvent) => this.documentClick(event)
    );
    this.clickListener = renderer.listen(
      'document',
      'mousemove',
      (event: MouseEvent) => this.documentClick(event)
    );
  }
  loginInfoObj = null;
  isLoggedin = null;
  currentTitle: any;
  currentDescription;
  currentType;
  searchFAQList;
  notificationTypeId;
  id;
  notificationItems = [];
  searchText = '';
  getNotificationDetails_obj = {};
  getNotificationDetails_obj_submit = {}
  count = 0;
  ticks = 0;
  countA = 0;
  beforeExpiryTime = 5;
  beforeExpiryTimeA = 5;
  userIdleTime = 15;

  timerFlag:boolean = false;
  ticksA =0;
  subA:Subscription;
  minutesDisplayA: number = 0;
  hoursDisplayA: number = 0;
  secondsDisplayA: number = 0;
  private playPauseStopUnsubscribe: any;
  clickListener: () => void;
  minutesDisplay = 0;
  hoursDisplay = 0;
  secondsDisplay = 0;
  private play = false;
  private pause = false;
  private stop = false;
  public playPauseStop$ = new EventEmitter();
  sub: Subscription;
  titleMessage = '';
  detailMessage = '';
  subtitleMessage = '';
  timerClicked = false;
  timeoutComplete = false;
  detectUrlChange = false;
  expiryTime: any;
  dropdown:Dropdown;
  currentSelection = 0;
  
  documentClick(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
        this.detectUrlChange = true;
        this.loginInfoObj = JSON.parse(this.returnLoginInfoObj());

        if (this.loginInfoObj !== null && this.detectUrlChange) {
         this.isLoggedin = this.loginInfoObj;
         this.stopTimer();
         this.startTimer();
         this.stopTimerA();
         this.startTimerA();

       } else {
         this.isLoggedin = null;
       }
        // console.log("target >>>> "+event.target+" : "+this.detectUrlChange);
    }else{
      this.detectUrlChange = false;
    }
  }
  ngOnInit(): void {}
  ngDoCheck() {
    this.loginInfoObj = JSON.parse(this.returnLoginInfoObj());
    this.expiryTime = Number(window.localStorage.getItem('timeout'));
    // console.log("loginINfoObj >>> "+JSON.stringify(this.loginInfoObj))
     //this.expiryTime = 3;
     if(this.expiryTime != null && !this.timerFlag && this.minutesDisplayA == ((this.expiryTime-1)-(this.beforeExpiryTimeA)) && this.secondsDisplayA ==59){
      // console.log("1 this.timerFlag--"+ this.timerFlag);
       this.timerFlag=true;
      // console.log("2 this.timerFlag--"+ this.timerFlag);
      
       this._notification.renewToken().subscribe(
         (response) => {
           console.log('refresh api response---'+JSON.stringify(response));
           window.localStorage.setItem('token', response.token_id);
           window.localStorage.setItem('refresh_token', response.refresh_token.token_id);
           window.localStorage.setItem('timeout', response.expireIn);
           this.expiryTime = Number(window.localStorage.getItem('timeout'));
           console.log(" calling stop time");
           this.stopTimerA();
           this.startTimerA(); 
         },
         (err) => {
           console.log("ERROR: " + err);
         },
         () => {
           console.log("COMPLETED");
         }
       )
     }
 
 
 
 
     if (this.loginInfoObj !== null) {     
       this.isLoggedin = this.loginInfoObj;
       this.textDir = sessionStorage.getItem('textDir');
        /* if(this.secondsDisplay == 5 ){
          
          this.titleMessage="Session timeout";
          let timerMinute = (this.userIdleTime-1)-this.minutesDisplay;
          let minutesStr = this.translate.instant('minutes');
          let secStr = this.translate.instant('seconds');
          let secondisplayTxt = 60-this.secondsDisplay;
          this.subtitleMessage = this.translate.instant('Your session will expire in',{timerMinute: timerMinute, minutesStr: minutesStr, secondsDisplay: secondisplayTxt, secStr: secStr});
          this.detailMessage=this.translate.instant('Continue to the Login page')
          this.showDialog();
        } */
       if(this.userIdleTime != null && this.timeoutComplete )
       {
         this.logoutFunc();
         this.titleMessage=this.translate.instant('Session timeout');
         this.subtitleMessage=this.translate.instant('Your session has expired');
         this.detailMessage=this.translate.instant('Continue to the Login page');
         if(!this.timerClicked){
          this.showDialog();           
         }
       }  
      if(this.userIdleTime != null && this.minutesDisplay >= (this.userIdleTime-this.beforeExpiryTime) && this.minutesDisplay <(this.userIdleTime)){
    
         this.titleMessage="Session timeout";
         let timerMinute = (this.userIdleTime-1)-this.minutesDisplay;
         let minutesStr = this.translate.instant('minutes');
          let secStr = this.translate.instant('seconds');
         if(timerMinute == 1){
           minutesStr = this.translate.instant('minute');
         }else{
           minutesStr = this.translate.instant('minutes');
         }
         if(this.secondsDisplay == 59){
           secStr = this.translate.instant('second');
         }else{
           secStr = this.translate.instant('seconds');
         }
         if(timerMinute != 0){
          let secondisplayTxt = 60-this.secondsDisplay;
          this.subtitleMessage = this.translate.instant('Your session will expire in',{timerMinute: timerMinute, minutesStr: minutesStr, secondsDisplay: secondisplayTxt, secStr: secStr});
          //  this.subtitleMessage="Your session will expire in "+(timerMinute)+" "+minutesStr+" "+(60-this.secondsDisplay)+" "+secStr;
        }
        else{
          let secondisplayTxt = 60-this.secondsDisplay;
          this.subtitleMessage = this.translate.instant('Your session will expire in 1', {secondsDisplay: secondisplayTxt, secStr: secStr});
          // this.subtitleMessage="Your session will expire in "+(60-this.secondsDisplay)+" "+secStr;
        }
       /*  else{
         this.subtitleMessage="Your session will expire in "+(60-this.secondsDisplay)+" "+secStr;
        } */
         this.detailMessage=this.translate.instant('Continue to work or Log Out');
         if(!this.timerClicked){
           this.showDialog();
         }
         //console.log("timerclicked 2 >>> "+(this.minutesDisplay)+">>> "+this.secondsDisplay)
         if(this.minutesDisplay==(this.userIdleTime-1) && this.secondsDisplay==59){
           console.log("timeoutComplete")
 
           this.timeoutComplete = true;
         }
         
       }
 
     } else {
       this.isLoggedin = null;
     }

    // this.isLoggedin = window.localStorage.getItem('loginInfoObj');
    /* if(this.loginInfoObj!=null){
      this.getAllNotifications(this.loginInfoObj)
    } */
  }
  showDialog(){
    this.timeoutDialog = new Dialog(this.timerDialog.nativeElement);
    this.timeoutDialog.show();
  }
  closeDialog(){
    this.timeoutDialog = new Dialog(this.timerDialog.nativeElement);
    this.timeoutDialog.hide();
  }
  showDropdown(){
    const dropDwn = new Dropdown(this.logoutDropdown.nativeElement);
    dropDwn.init(); 
    const dropDownMenu = new Menu(this.logoutMenu.nativeElement);
    dropDownMenu.show(); 
  }
  resetTimer(){
    this.stopTimer();
    this.startTimer();
  }
  changeLang(val){
    window.localStorage.setItem('selectedLang', val);
  }
  openNotification() {
    this.getAllNotifications(this.loginInfoObj)
    //jQuery('#notificationRightModal').addClass("is-visible")
  }
  closeNotification() {
    //jQuery('#notificationRightModal').removeClass("is-visible")
  }
  openNotificationSuccess() {
    /* jQuery('#notificationModal').modal('hide');
    jQuery('#helpRightModal').modal('hide');
    jQuery('#notificationSuccess').modal('show'); */
  }
  openHelp() {
    this.closeNotification();
    this.getHelpFAQ();
    /*  jQuery('#helpRightModal').addClass("is-visible")*/   
  }
  dummy() {
    alert("Work in progress");
  }
  chkDate(date){
    const currentDate = new Date(date);
    return currentDate;
  }
  continueSession(){
    //alert(this.timeoutComplete+" : "+this.minutesDisplay)
    if (this.timeoutComplete) {
      /* jQuery('#timeOutModal').modal('hide'); */
      this.closeDialog();
      this.timerClicked = true;
     
      this.logoutFunc();
      this.timeoutComplete =false;
    }else{
      console.log("continuesession 2 >>> "+this.minutesDisplay)
      this.stopTimer();
      this.timerClicked = true;
      /* jQuery('#timeOutModal').modal('hide'); */
      this.closeDialog();
      this.startTimer();
    }
  }

  logoutSession(){
   /*  jQuery('#timeOutModal').modal('hide'); */
   this.closeDialog();
    console.log(' logout timeOutModal');
   //.this.stopTimer();
    this.timerClicked = true;
    this.logoutFunc();
  }
  openNotificationModal(reqId) {
    this.closeNotification();

    this.getRequestData(reqId);
    /* jQuery('#notificationModal').modal({
      backdrop: true
    }); */
  }
  dispRole() {
    let dispRole;
    let leadType:object | null;
    leadType = this.loginInfoObj.role.lead;
    if (leadType){
     dispRole = this.loginInfoObj.role.lead.type + ' ' + this.loginInfoObj.role.desc;
    } else {
     dispRole = this.loginInfoObj.role.desc;
    }
    return dispRole;
  }
  returnLoginInfoObj() {
    return window.localStorage.getItem('loginInfoObj');
  }
  returnExpiryInfoObj() {
    return window.localStorage.getItem('timeout');
  }
  logoutFunc() {
    this.stopTimer();
    this.timerClicked = false;
    this.timeoutComplete = false;
    this.closeNotification(); 
    window.localStorage.clear();
    this.isLoggedin = null;
    this.router.navigate(['/login']);
  }

  getAllNotifications(data) {
    this._notification.getNotificationList(data).subscribe(
      (response) => {
        this.notificationItems = response;
        return this.notificationItems;
      },
      (err) => {
        console.log("ERROR: " + err);
      },
      () => {
        console.log("COMPLETED");
      }
    );
  }

  getHelpFAQ() {
    this.helpService.getFAQList().subscribe(
      (response) => {
        this.searchFAQList = response;
      },
      (err) => {
        console.log("ERROR: " + err);
      },
      () => {
        console.log("COMPLETED");
      }
    );
  }
  getStyle(val) {
    if (val !== this.currentSelection) {
      return 'dispNone';
    } else {
      return 'dispBlock';
    }
  }
  currentSelectedGrade(val) {
    this.currentSelection = val;
  }

  getStyleGrade(val) {
    if (val !== this.currentSelection) {
      return 'init-arrow-down ';
    } else {
      return 'arrow-up active';
    }
  }
  getRequestData(data) {
    this._notification.getNotificationDetails(data).subscribe(
      (response) => {
        console.log('details');
        console.log(response);
        this.getNotificationDetails_obj_submit = response;
        this.getNotificationDetails_obj = response.details;
        return this.getNotificationDetails_obj;
      },
      (err) => {
        console.log("ERROR: " + err);
      },
      () => {
        console.log("COMPLETED");
      }
    );
  }
  submitResolutionData(obj,status,currentObj) {
    this._notification.getNotificationResolution(obj, status, currentObj).subscribe(
      (response) => {
        console.log('successfully submitted');
        this.openNotificationSuccess();
        /* console.log(response)
        this.getNotificationDetails_obj= response.details;
         return this.getNotificationDetails_obj; */
      },
      (err) => {
        console.log("ERROR: " + err);
      },
      () => {
        console.log("COMPLETED");
      }
    );
  }
  resolutionSubmit(status){
    const tempDescription = jQuery('#resolution_txt').val();
    const currentObj = {
      user_id: this.loginInfoObj.user_id,
      role: this.loginInfoObj.role,
      currentTitle: this.currentTitle,
      currentDescription: this.currentDescription,
      currentType: this.currentType,
      currentTypeId: this.notificationTypeId,
      resolutionComment: tempDescription,
      _id: this.id
    };
    this.submitResolutionData(this.getNotificationDetails_obj_submit, status, currentObj);
  }

  setGlobalVar(title, description, type, typeid, id ){
    this.currentTitle = title;
    this.currentDescription = description;
    this. currentType = type;
    this.notificationTypeId = typeid;
    this.id = id;
  }

  private startTimer() {
    const timers = timer(1, 1000);
    this.sub = timers.subscribe(
      t => {
          this.ticks = t;
          this.secondsDisplay = this.getSeconds(this.ticks);
          this.minutesDisplay = this.getMinutes(this.ticks);
          this.hoursDisplay = this.getHours(this.ticks);
      }
    );
  }
  private getSeconds(ticks: number) {
    return this.pad(ticks % 60);
  }

  private getMinutes(ticks: number) {
    return this.pad((Math.floor(ticks / 60)) % 60);
  }

  private getHours(ticks: number) {
    return this.pad(Math.floor((ticks / 60) / 60));
  }

  private pad(digit: any) {
    return digit <= 9 ? '0' + digit : digit;
  }
  private stopTimer() {
     this.ticks = 0;
     this.count = 0;
     this.minutesDisplay = 0;
     this.hoursDisplay = 0;
     this.secondsDisplay = 0;
     if (this.sub) {
      this.sub.unsubscribe();
     }
  }




  

  private startTimerA() {
    //console.log("startTimerA")
    const timerA = timer(1, 1000);
        this.subA = timerA.subscribe(
            tA => {
                this.ticksA = tA;                
                this.secondsDisplayA = this.getSeconds(this.ticksA);
                this.minutesDisplayA = this.getMinutes(this.ticksA);
                this.hoursDisplayA = this.getHours(this.ticksA);
            }
        ); 
      
    }
    
    private getSecondsA(ticks: number) {
        return this.padA(ticks % 60);
    }
    
    private getMinutesA(ticks: number) {
         return this.padA((Math.floor(ticks / 60)) % 60);
    }
    
    private getHoursA(ticks: number) {
        return this.padA(Math.floor((ticks / 60) / 60));
    }
    
    private padA(digit: any) { 
        return digit <= 9 ? '0' + digit : digit;
    }
    private stopTimerA() {
     //console.log("stopTimerA")
      this.ticksA = 0;
      this.countA = 0;
      this.minutesDisplayA = 0;
      this.hoursDisplayA = 0;
      this.secondsDisplayA = 0;
      this.timerFlag = false;
      if (this.subA) this.subA.unsubscribe();
    }
}
